export default __webpack_public_path__ + "static/media/element_29.81cceb66.webp";